module.exports = __webpack_public_path__ + "static/media/anjum3.1a6d7e4a.jpeg";